// getCampaignDetails/getAllCampaigns return scheduledAt as a UTC "Y-m-d H:i:s"
// string (no timezone marker) — append Z so Date parses it as UTC instead of
// the browser's own local zone, then render it back out in IST for display.
export const formatUTCToIST = (utcDatetime) => {
    if (!utcDatetime) return '—';
    const isoish = utcDatetime.includes('T') ? utcDatetime : utcDatetime.replace(' ', 'T');
    const withZone = /Z|[+-]\d{2}:?\d{2}$/.test(isoish) ? isoish : `${isoish}Z`;
    const d = new Date(withZone);
    if (isNaN(d.getTime())) return utcDatetime;
    return d.toLocaleString('en-IN', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: true
    });
};

// holdStatus/scheduledAt/broadcastJobId reflect the LATEST hold row for a
// campaign — this is the single source of truth for "what state is this
// campaign actually in", proven out in CampaignLaunch.js. Reused here so the
// campaign list and the detail page never disagree on what a given
// campaign's state means.
export const deriveSendState = ({ holdStatus, scheduledAt, broadcastJobId }) => {
    const isScheduledNotFired = holdStatus === 'HELD' && !!scheduledAt && !broadcastJobId
    const isFiring = !!broadcastJobId && (holdStatus === 'HELD' || holdStatus === 'SETTLED')

    if (!holdStatus) return { key: 'draft', label: 'Draft', isScheduledNotFired, isFiring }
    if (isScheduledNotFired) return { key: 'scheduled', label: 'Scheduled', isScheduledNotFired, isFiring }
    if (isFiring) return { key: 'sending', label: holdStatus === 'SETTLED' ? 'Sent' : 'Sending', isScheduledNotFired, isFiring }
    if (holdStatus === 'RELEASED') return { key: 'cancelled', label: 'Cancelled', isScheduledNotFired, isFiring }
    return { key: 'unknown', label: holdStatus, isScheduledNotFired, isFiring }
}
